module.exports = __webpack_public_path__ + "static/img/alltagskulturen.690d4ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/alltagskulturen.png
// module id = hNxH
// module chunks = 0